import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

import { activeTenant } from '@app/tenant';
import { readTenantEnv } from '@app/tenant/env';

let initialized = false;

export const useGoogleTagManager = () => {
  useEffect(() => {
    const gtmId = activeTenant ? readTenantEnv(activeTenant.slug, 'GOOGLE_TAG_MANAGER_KEY') : undefined;

    if (gtmId && !initialized) {
      TagManager.initialize({ gtmId });
      initialized = true;
    } else {
      console.error('Google Tag Manager failed to initialize.');
    }
  }, []);
};
